import { useState, useEffect } from "react";
import EditIcon from "@mui/icons-material/Edit";
import {
  Typography,
  Box,
  TextField,
  Dialog,
  DialogTitle,
  IconButton,
  Button,
  CardMedia,
} from "@mui/material";
import OrdersListGrid from "./OrdersListGrid";
import SubmitButton from "./SubmitButton";
import giftIcone from "../../images/icon/giftbox.png";
import operatorD from "../../images/icon/operatorD.png";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function OrdersList(props) {
  const [openInf, setOpenInf] = useState({
    show: false,
  });
  const { isSmall } = useBreakpoints();

  const [state, setState] = useState({
    postFollowupCode: "",
  });

  useEffect(() => {
    if (openInf.show == true) {
      setState({
        operatorDescription: props.orderDetail.operatorDescription,
      });
    }
  }, [openInf]);

  return (
    <Box>
      <Dialog
        fullWidth
        maxWidth="xs"
        onClose={() => {
          setOpenInf({
            show: false,
          });
          setState({
            operatorDescription: "",
          });
        }}
        open={openInf.show}
      >
        <DialogTitle>ویرایش توضیحات اپراتور</DialogTitle>
        <Box
          sx={{
            mx: 3,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <TextField
            autoFocus
            fullWidth
            value={state.operatorDescription ? state.operatorDescription : ""}
            label="توضیحات اپراتور"
            size="small"
            variant="outlined"
            multiline
            rows={6}
            onChange={(evt) => {
              setState({
                ...state,
                operatorDescription: evt.target.value,
              });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <SubmitButton
              Value={state.operatorDescription}
              FiledName="description"
              id={props.orderDetail.id}
              callback={() => {
                props.setOrderDetail({
                  ...props.orderDetail,
                  operatorDescription: state.operatorDescription,
                });
                setOpenInf({ ...openInf, show: false });
              }}
            />
            <Button
              sx={{ ml: 1 }}
              color="error"
              variant="outlined"
              onClick={() => setOpenInf({ ...openInf, show: false })}
            >
              انصراف
            </Button>
          </Box>
        </Box>
      </Dialog>
      <Box sx={{ p: 2, mb: 2 }}>
        <Typography sx={{ mb: 2 }} color="secondary" variant="h6">
          اطلاعات سفارش
        </Typography>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
          <Box gridColumn="span 12">
            <OrdersListGrid
              rows={props.orderDetail.orders ? props.orderDetail.orders : []}
            />
          </Box>
          <Box
            gridColumn={isSmall ? "span 12" : "span 6"}
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={giftIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                هدیه
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 5,
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                display: "flex",
                py: 1,
                px: 2,
              }}
            >
              <Typography
                sx={{
                  textAlign: "left",
                  color: "#3e485c",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.orderGift
                  ? props.orderDetail.orderGift.name +
                    " کد " +
                    props.orderDetail.orderGift.id
                  : ""}
              </Typography>
              <IconButton
                onClick={() =>
                  setOpenInf({
                    show: true,
                    dialogeContent: "postFollowupCode",
                  })
                }
                sx={{ p: 0, visibility: "hidden" }}
              >
                <EditIcon fontSize="small" color="secondary" />
              </IconButton>
            </Box>
          </Box>
          {!isSmall && <Box gridColumn="span 6"></Box>}
          <Box
            gridColumn="span 12"
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={operatorD}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                توضیحات اپراتور
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 3,
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                display: "flex",
                justifyContent: "space-between",
                py: 1,
                px: 2,
                height: "100px",
                alignItems: "flex-start",
              }}
            >
              <Typography
                sx={{
                  textAlign: "left",
                  color: "#3e485c",
                  // whiteSpace: "pre-line",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.operatorDescription}
              </Typography>
              <IconButton
                onClick={() =>
                  setOpenInf({
                    show: true,
                    dialogeContent: "postFollowupCode",
                  })
                }
              >
                <EditIcon fontSize="small" color="secondary" />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
